module.exports = __webpack_public_path__ + "static/media/GooglePlay.6329ed78.jpg";